export default __webpack_public_path__ + "static/image19-e232e6a14a405f1ce80df022a4b9599b.webp";